"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const calendar_1 = require("@kyruus/calendar");
const react_1 = require("@xstate/react");
const moment_1 = __importDefault(require("moment"));
const react_2 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const messages_1 = __importDefault(require("../../../lib/messages"));
const ApptList_utils_1 = require("../../../ManageAppointment/components/ApptTime/ApptList.utils");
const GroupedAppts_1 = __importDefault(require("../../../ManageAppointment/components/ApptTime/GroupedAppts"));
const styles_1 = require("../../../ManageAppointment/components/ApptTime/styles");
const useManageAppointmentContext_1 = require("../../../ManageAppointment/hooks/useManageAppointmentContext");
const Events_1 = require("../../../ManageAppointment/lib/constants/Events");
const Tracking_1 = require("../../../ManageAppointment/lib/constants/Tracking");
const styles_2 = require("./styles");
const ApptList = ({ service }) => {
    const [isDatePickerFocused, setIsDatePickerFocused] = (0, react_2.useState)(false);
    const { track } = (0, useManageAppointmentContext_1.useManageAppointmentContext)();
    const [currentState, send] = (0, react_1.useService)(service);
    const { provider, availableSlots, jumpedToDate, filterBy } = currentState.context;
    const batchedAvailableSlots = Object.entries((0, react_2.useMemo)(() => (0, ApptList_utils_1.batchAvailableSlotsByDay)(availableSlots, filterBy), [availableSlots, filterBy]));
    const onSelectAppt = (selectedSlot) => {
        // To-Do: Tracking event will be changed to a more specific one in the future JIRA Issue
        track(Tracking_1.userEvents.APPT_SELECT_SLOT, selectedSlot);
        send({
            type: Events_1.SELECT_APPOINTMENT,
            context: { selectedSlot: selectedSlot }
        });
    };
    const onDateChange = (date) => {
        // To-Do: Tracking event will be changed to a more specific one in the future JIRA Issue
        track(Tracking_1.userEvents.APPT_JUMP_TO_DATE);
        send({
            type: Events_1.JUMP_TO_DATE,
            data: { periodStart: date.format('YYYY-MM-DD') }
        });
    };
    return (react_2.default.createElement(styles_2.StyledContainer, null,
        react_2.default.createElement(calendar_1.SingleDatePickerDropdown, { focused: isDatePickerFocused, onFocusChange: ({ focused }) => setIsDatePickerFocused(focused || false), date: jumpedToDate ? (0, moment_1.default)(jumpedToDate) : (0, moment_1.default)(), onDateChange: onDateChange, label: react_2.default.createElement(react_intl_1.FormattedMessage, Object.assign({}, messages_1.default.dateFilterLabel)), block: true, numberOfMonths: 1, hideKeyboardShortcutsPanel: true }),
        react_2.default.createElement(styles_1.AppointmentSlotListContainer, null, batchedAvailableSlots.map(([date, slots]) => (react_2.default.createElement(GroupedAppts_1.default, { key: date, headerDate: date, availableSlotData: slots, onSelectAppt: onSelectAppt, provider: provider }))))));
};
exports.default = ApptList;
//# sourceMappingURL=ApptList.js.map